var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppointmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98.576,
    height: 98.576,
    viewBox: "0 0 98.576 98.576",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "appointment-new-svgrepo-com",
    d: "M40.046,0a40.046,40.046,0,0,0,0,80.093c1.035,0,2.07-.048,3.08-.12V67.6a26.142,26.142,0,0,1-3.08.168A27.724,27.724,0,1,1,67.771,40.046a26.14,26.14,0,0,1-.168,3.08h12.37c.072-1.011.12-2.046.12-3.08A40.139,40.139,0,0,0,40.046,0Zm0,18.483a3.071,3.071,0,0,0-3.08,3.08v15.4H27.724a3.08,3.08,0,0,0,0,6.161H40.046a3.071,3.071,0,0,0,3.08-3.08V21.563A3.071,3.071,0,0,0,40.046,18.483Zm27.724,30.8V67.771H49.288V80.093H67.771V98.576H80.093V80.093H98.576V67.771H80.093V49.288Zm0,0",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentIcon);
export default __webpack_public_path__ + "static/media/appointmentIcon.5684a6af14f85073e425b251d1487b93.svg";
export { ForwardRef as ReactComponent };